import globalConfig from '../../config/global-variables';
import modelBaseV2 from '../model-base-v2.model';

const chatbotModel = {
  /**
   * Fetch chat session history
   * @returns Promise<{ sessions: Array<{ sessionId, topic, createDate }> }>
   */
  getChatLog: function () {
    return modelBaseV2.get(`${globalConfig.ADSSO_API_URL}/mcs_ai/api/chat/chatlog`);
  },

  /**
   * Fetch conversation messages for a specific session
   * @param {string} sessionId
   * @returns Promise<Array<{ message, reply, timestamp }>>
   */
  getChatSession: function (sessionId) {
    return modelBaseV2.get(`${globalConfig.ADSSO_API_URL}/mcs_ai/api/chat/chatlog/${sessionId}?responseType=html`);
  },

  /**
   * Send a chat message to the API
   * @param {string} sessionId - The chat session ID
   * @param {string} message   - The user's message text
   * @returns Promise<{ reply: string, toolCallsUsed: string[], totalMessages: number }>
   */
  sendMessage: function (sessionId, message) {
    return modelBaseV2.post(`${globalConfig.ADSSO_API_URL}/mcs_ai/api/chat?responseType=html`, {
      body: { sessionId, message }
    });
  }
};

export default chatbotModel;
